var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0485 14.7806C10.9079 14.9211 10.7173 15 10.5185 15C10.3198 15 10.1291 14.9211 9.98849 14.7806L7.23834 12.0305C7.16464 11.9618 7.10554 11.879 7.06454 11.787C7.02355 11.695 7.00151 11.5957 6.99973 11.495C6.99795 11.3943 7.01648 11.2942 7.0542 11.2009C7.09193 11.1075 7.14807 11.0226 7.2193 10.9514C7.29052 10.8802 7.37536 10.824 7.46875 10.7863C7.56214 10.7486 7.66218 10.7301 7.76289 10.7318C7.86359 10.7336 7.96291 10.7557 8.05492 10.7966C8.14692 10.8376 8.22973 10.8967 8.29839 10.9704L9.76847 12.4405V4.75004C9.76847 4.55112 9.8475 4.36034 9.98816 4.21968C10.1288 4.07902 10.3196 4 10.5185 4C10.7174 4 10.9082 4.07902 11.0489 4.21968C11.1895 4.36034 11.2686 4.55112 11.2686 4.75004L11.2686 12.4405L12.7386 10.9704C12.8808 10.838 13.0689 10.7658 13.2632 10.7693C13.4575 10.7727 13.6429 10.8514 13.7803 10.9888C13.9177 11.1262 13.9965 11.3116 13.9999 11.5059C14.0033 11.7003 13.9312 11.8883 13.7987 12.0305L11.0485 14.7806Z",
    fill: "#808086"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.62564c6c63b5fdff81c5308efc9573ed.svg";
export { ForwardRef as ReactComponent };